import React from 'react';
import { Button, Badge } from '@mui/material';
import { Tune as TuneIcon } from '@mui/icons-material';
import { appColors } from '../../Config/Theme';

interface FiltersButtonProps {
  onClick: () => void;
  activeFilterCount?: number;
}

const FiltersButton: React.FC<FiltersButtonProps> = ({ onClick, activeFilterCount = 0 }) => {
  const hasActive = activeFilterCount > 0;
  const label = hasActive ? `Filters (${activeFilterCount})` : 'Filters';

  const button = (
    <Button
      variant="outlined"
      startIcon={<TuneIcon sx={{ fontSize: 18 }} />}
      onClick={onClick}
      aria-label="Open filters"
      title="Open filters"
      sx={{
        minHeight: 40,
        borderRadius: '999px',
        fontWeight: 600,
        fontSize: '0.85rem',
        textTransform: 'none',
        px: 2.5,
        bgcolor: hasActive ? `${appColors.primary.main}0A` : appColors.surface.card,
        color: appColors.primary.main,
        borderColor: appColors.primary.main,
        borderWidth: '1.5px',
        '& .MuiButton-startIcon': { color: appColors.primary.main },
        '&:hover': {
          bgcolor: `${appColors.primary.main}14`,
          borderColor: appColors.primary.main,
          borderWidth: '1.5px',
        },
        '&:focus-visible': {
          outline: `2px solid ${appColors.primary.main}`,
          outlineOffset: 2,
        },
      }}
    >
      {label}
    </Button>
  );

  if (!hasActive) return button;

  return (
    <Badge
      badgeContent={activeFilterCount}
      color="primary"
      sx={{
        '& .MuiBadge-badge': {
          fontWeight: 700,
          fontSize: '0.65rem',
          minWidth: 18,
          height: 18,
        },
      }}
    >
      {button}
    </Badge>
  );
};

export default React.memo(FiltersButton);
